import CryptoJS from "crypto-js"
import { getEncryptionKey } from '../api/axios';


export const encrypt = async (data) => {
    try {
        const secretKey = await getEncryptionKey();

        const stringifiedData = JSON.stringify(data); // Ensure data is converted to a string
        return CryptoJS.AES.encrypt(stringifiedData, secretKey).toString();
    } catch (error) {
        console.error("Encryption failed:", error);
        return null;
    }
};

// Decrypt function
export const decrypt = async (encryptedData) => {
    try {
        const secretKey = await getEncryptionKey();

        const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
        const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedString); // Convert back to the original object
    } catch (error) {
        console.error("Decryption failed:", error);
        return null;
    }
};







